import { useEffect, useRef, useState } from "react";
import { useCookies } from 'react-cookie';
import GetServiceNameImagePath from "./GetServiceNameImagePath";
function Footer({ isOpen, k_id, war_id, myKDName, myPoints, regionDetails, war_data }) {
    // console.log('myPoints', myPoints)
    const bottomDrawer = useRef(null);
    const rmUserPointsModal = useRef(null);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [allServicesData, setAllServicesData] = useState([]);
    const [distRanking, setDistRanking] = useState([]);
    const [userRMPointsModel, setUserRMPointsModel] = useState([]);
    const [isFlipped, setIsFlipped] = useState(false);
    const [cookies] = useCookies(['user']);
    const [showBackdrop, setShowBackdrop] = useState(false);
    const user_id = cookies.user_id;
    const token = cookies.token;
    let userType = localStorage.getItem("user_type");
    const [sortingToggle, setSortingToggle] = useState(true);
    let rmHideDiv = { "display": "none" };
    let distHideDiv = { "display": "none" };
    if (userType === 'rm' || userType === 'admins') {
        rmHideDiv = { "display": "block" };
    } else {
        distHideDiv = { "display": "block" };
    }

    const orderToggle = () => {
        if (sortingToggle) {
            setIsFlipped((prev) => !prev);
            setSortingToggle(false)
            pointsOrdering(false);
        } else {
            setIsFlipped((prev) => !prev);
            setSortingToggle(true)
            pointsOrdering(true);
        }
    }
    const defaultBottomDrawer = (flag) => {
        if (flag === true && isOpen === true) {
            const timer = setTimeout(() => {
                if (bottomDrawer.current) {
                    bottomDrawer.current.style.transform = 'translateY(0)';
                }
            }, 1000);
            return () => clearTimeout(timer);
        }
    }
    useEffect(() => {
        if (userType === 'rm' || userType === 'admins') {
            defaultBottomDrawer(war_data.show_brahmastra_ani_rm);
        } else {
            defaultBottomDrawer(war_data.show_brahmastra_ani);
        }
    }, [war_data]);
    useEffect(() => {
        if (!isOpen) {
            bottomDrawer.current.style.transform = 'translateY(100%)';
        }
    }, [isOpen]);
    const handleFooterClick = () => {
        // if (isOpen === false) {
        //     setIsDrawerOpen(true);
        // }
        // setIsDrawerOpen(prevState => !prevState);
        setIsDrawerOpen((prevState) => {
            const newDrawerState = !prevState;

            // Toggle backdrop visibility when drawer state changes
            setShowBackdrop(newDrawerState);

            return newDrawerState;
        });
    };

    const handleDrawerFooterClick = () => {
        setIsDrawerOpen(false);
        setShowBackdrop(false);
    };

    const pointsOrdering = (orderFlag) => {

        let data = localStorage.getItem("war_breakup");
        data = JSON.parse(data);
        let servicesBasedHtml = [];
        let usersData = data.user_data;
        usersData.sort((a, b) => b['total_points'] - a['total_points']);
        let keyProp = 1;
        data.all_factor.forEach((services, index) => {
            let allPoints = 0;
            let userBasedHtml = [];
            let counter = 1;
            if (services == "all") {
                usersData.sort((a, b) => b['total_points'] - a['total_points']);
                if (orderFlag === false) {
                    usersData.sort((a, b) => a['total_points'] - b['total_points']);
                }
            } else {
                usersData.sort((a, b) => b[services] - a[services]);
                if (orderFlag === false) {
                    usersData.sort((a, b) => a[services] - b[services]);
                }
            }
            usersData.forEach((userEl, userIndex) => {
                if (services==='Saarthi_Bonus' && !userEl[services]>0) {
                    return;
                }
                if (Object.keys(userEl).includes(services)) {
                    allPoints = userEl[services];
                } else if (services == "all") {
                    allPoints = 0;
                    Object.keys(userEl).forEach((userServices) => {
                        if (data.all_factor.includes(userServices)) {
                            allPoints = allPoints + userEl[userServices];
                        }
                    })
                }
                const totalUsers = usersData.filter(u => {
                    if (services === 'Saarthi_Bonus' && !u[services] > 0) return false;
                    return Object.keys(u).includes(services) || services === "all";
                }).length;
                
                const displayCounter = orderFlag === false ? (totalUsers - userIndex) : counter;
                userBasedHtml.push(
                    <div key={"keyprop_" + displayCounter} className="servicebox1 mb-3" onClick={() => openUserRmPointsModel(userEl)}>
                        <div className="points-numberbox">
                            <span className="pn-rating">{displayCounter}</span>
                        </div>
                        <div className="servicebox-inner">
                            <div className="servicename ml-3 mt-1 mb-1">
                                <span className="fname">{userEl.shop_name}</span> <br />
                                <span className="s1">{userEl.dist_name}</span>
                            </div>
                            <div className="servicepoints d-flex align-items-center mr-4 mt-1">
                                <span className="sp1">{allPoints}</span>
                                <img src="../images/BOR/points-coins.png" className="img-service-point"
                                    alt="point" />
                            </div>
                        </div>
                    </div>
                )
                counter = counter + 1;
            });
            let activeShow = services == "all" ? "tab-pane fade active show" : "tab-pane fade";
            servicesBasedHtml.push(
                <div key={index + "_index"} className={activeShow} id={services.toLowerCase()} role="tabpanel">
                    {userBasedHtml}
                </div>
            )
            keyProp = keyProp + 1;
        });
        setDistRanking(servicesBasedHtml);
    }
    const openUserRmPointsModel = (userEl) => {
        let all_data = localStorage.getItem("war_breakup");
        let userRMPointsModelTemp = [];
        // console.log('userData', userEl);
        all_data = JSON.parse(all_data);
        let all_factor = all_data.all_factor;
        delete all_factor[all_factor.indexOf('all')];
        console.log('all factor', all_factor);
        userRMPointsModelTemp.push(
            <>
                <div key={"dist_name" + userEl.shop_name} className="modal-header-title mt-3 mb-3 pl-2">
                    <span data-dismiss="modal" aria-label="Close"><i
                        className="fa fa-arrow-left" aria-hidden="true"></i></span>
                    <span className="ml-3">{userEl.shop_name}</span>
                </div>
            </>
        )
        let temp = []
        Object.keys(all_factor).forEach((services_key) => {
            let points = 0;
            if (userEl[all_factor[services_key] + '_points'] !== undefined) {
                points = userEl[all_factor[services_key] + '_points'];
            } else if (userEl[all_factor[services_key]] !== undefined) {
                points = userEl[all_factor[services_key]];
            }
            temp[all_factor[services_key]] = points;
        });
        console.log(temp);
        temp =  Object.fromEntries(Object.entries(temp).sort((a, b) => b[1] - a[1]));
        console.log(temp);
        Object.keys(temp).forEach((services_key) => {
            let points = temp[services_key];
            let serviceName = services_key;
            serviceName = serviceName.replaceAll("_", " ").replace(/\s+/g, " ").trim();
            let imgName = GetServiceNameImagePath(serviceName);
            console.log(`img -: ${imgName}`);
            let img = require("./../../images/" + imgName).default;

            if (serviceName === 'Utility Bill Payment'){
                serviceName = 'Bill Payment'
            } else if (serviceName === 'Daily Invest') {
                serviceName = 'Daily Reserve'
            } else if (serviceName === 'Payment Gateway Credit Card') {
                serviceName = 'Payments';
            } else if (serviceName === 'Payment Gateway Partner Portal') {
                serviceName = 'Partner Portal';
                console.log('serviceName PGPP', serviceName)
            }

            if (serviceName==="Saarthi Bonus" && !points>0) {
                return;
            }
            userRMPointsModelTemp.push(
                <>
                    <div key={"services_key" + services_key} className="servicebox1-modal mb-3">
                        <div className="servicebox-inner-modal">
                            <div className="servicename ml-0 mt-0">
                                <img src={img} className="img-service"
                                    alt="irctc" />
                                <span className="s1 s1sm">{serviceName}</span>
                            </div>
                            <div className="servicepoints d-flex align-items-center mr-0 mt-0">
                                <img src="../images/BOR/points-coins.png"
                                    className="img-fluid img-service-point" alt="point" />
                                <span className="sp1">{points}</span>
                            </div>
                        </div>
                    </div>
                </>
            )
        })
        setUserRMPointsModel(userRMPointsModelTemp)
        rmUserPointsModal.current.click();
    }
    const getScoreDetails = async () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'token': token, 'userId': user_id },
            body: JSON.stringify({ user_id: user_id, k_id: k_id, war_id: war_id }),
        };
        console.log(requestOptions);
        const response = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-war-distributor-data', requestOptions);
        const data = await response.json();
        // console.log('await response.json()', await response.json())
        
        // const data = JSON.parse(dummyData);
        // console.log('dummyData', dummyData)
        if (data.status === "success") {
            let temp = [];
            const exceptionMap = {
                'Mobile_DTH_Recharge': 'Mobile/DTH Recharge',
                'Payment_Gateway___Partner_Portal__': 'Payment Gateway ( Partner Portal )',
                'Bill_Payment___Partner_Portal__':'Bill Payment ( Partner Portal )',
            };
            Object.keys(data.all_factor).forEach(function (key) {
                let temp_val = data.all_factor[key];
                let hrefData = "#" + temp_val.toLowerCase();
                if (exceptionMap[temp_val]) {
                    temp_val=exceptionMap[temp_val]
                }
                temp_val = temp_val.replaceAll("_", " ");
                if(temp_val === 'Utility Bill Payment'){
                    temp_val = 'Bill Payment'
                } else if(temp_val === 'Daily Invest') {
                    temp_val = 'Daily Reserve'
                } else if (temp_val === 'Payment Gateway Credit Card') {
                    temp_val = 'Payments';

                } else if (temp_val === 'Payment Gateway ( Partner Portal )') {
                    temp_val = 'Partner Portal';
                }
                temp.push(
                    <li key={key} className="nav-item navitem-head" data-services={data.all_factor[key].toLowerCase()}>
                        <a className="nav-link nav-linksp" data-toggle="pill" href={hrefData}
                            role="tab" aria-controls="pills-irctc" aria-selected="false">{temp_val}</a>
                    </li>
                )
            });

            data.all_factor.unshift("all");
            localStorage.setItem("war_breakup", JSON.stringify(data));
            // console.log(`data.all_factor -: `, data.all_factor);
            let servicesBasedHtml = [];
            let usersData = data.user_data;
            usersData.sort((a, b) => b['total_points'] - a['total_points']);
            let keyProp = 1;
            data.all_factor.forEach((services, index) => {
                let allPoints = 0;
                let userBasedHtml = [];
                let counter = 1;
                if (services == "all") {
                    usersData.sort((a, b) => b['total_points'] - a['total_points']);
                } else {
                    usersData.sort((a, b) => b[services] - a[services]);
                }
                usersData.forEach((userEl) => {
                    // console.log(`key -: ${key}  --- services ${data.all_factor}`);
                    if (services==='Saarthi_Bonus' && !userEl[services]>0) {
                        return;
                    }
                    if (Object.keys(userEl).includes(services)) {
                        allPoints = userEl[services];
                    } else if (services == "all") {
                        allPoints = 0;
                        Object.keys(userEl).forEach((userServices) => {
                            if (data.all_factor.includes(userServices)) {
                                allPoints = allPoints + userEl[userServices];
                            }
                        })

                        // console.log('allPoints', allPoints)
                    }
                    userBasedHtml.push(
                        <div key={"keyprop_" + counter} className="servicebox1 mb-3" onClick={() => openUserRmPointsModel(userEl)}>
                            <div className="points-numberbox">
                                <span className="pn-rating">{counter}</span>
                            </div>
                            <div className="servicebox-inner">
                                <div className="servicename ml-3 mt-1 mb-1">
                                    <span className="fname">{userEl.shop_name}</span> <br />
                                    <span className="s1">{userEl.dist_name}</span>
                                </div>
                                <div className="servicepoints d-flex align-items-center mr-4 mt-1">
                                    <span className="sp1">{allPoints}</span>
                                    <img src="../images/BOR/points-coins.png" className="img-fluid img-service-point"
                                        alt="point" />
                                </div>
                            </div>
                        </div>
                    )
                    counter = counter + 1;
                });
                let activeShow = services == "all" ? "tab-pane fade active show" : "tab-pane fade";
                servicesBasedHtml.push(
                    <div key={index + "_index"} className={activeShow} id={services.toLowerCase()} role="tabpanel">
                        {userBasedHtml}
                    </div>
                )
                keyProp = keyProp + 1;
            });
            // console.log('servicesBasedHtml', servicesBasedHtml)
            setDistRanking(servicesBasedHtml);
            setAllServicesData(temp);

        }
    }

    useEffect(() => {
        getScoreDetails();
    }, []);

    const [text, setText] = useState(null);
    const [showNewText, setShowNewText] = useState(false); // To control the fade effect

    useEffect(() => {
        setText(<span className="total-brahma-text">{war_data.my_brahmastra_added} New Bhramsatra Added </span>);
        const timer = setTimeout(() => {
            setShowNewText(true); // Trigger fade-in animation
            setText(<span className="total-brahma-text">Region's Total Brahmastra <br /> <span className="total-bpoints">{war_data.my_kd_brahmastra}</span></span>);
        }, 6000);
        return () => clearTimeout(timer);
    }, [war_data]);
    return (
        <>
            {showBackdrop && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        zIndex: 100,
                    }}
                    onClick={() => {
                        setIsDrawerOpen(false);
                        setShowBackdrop(false);
                    }}
                ></div>
            )}
            <footer id="footerToggle" onClick={handleFooterClick}>
                <div className="outercontainer">
                    <p className="teamnamef">{myKDName}</p>

                    <div ref={bottomDrawer} id="bottomDrawer" className="drawer bottom-drawer" style={{ transform: 'translateY(100%)' }}>
                        <footer id="drawerFooter">
                            <div className="outercontainer">

                                <p className="teamnamefbtfooter">{myKDName}</p>
                            </div>
                        </footer>
                        <div className="points-box-bottom rmpb-bottom">
                            {
                                (userType === 'rm' || userType === 'admins') ?
                                    <>
                                        <p>Points added in last {war_data.rm_time}</p>
                                        <p>{war_data.my_pts_added}</p>
                                        <p>Brahmastra completed : {war_data.my_brahmastra_added_rm}
                                        </p>
                                    </> :
                                    <>
                                        {/* <h1 style={{"color" : "white"}}>Distributor code goes here!!</h1> */}
                                        <div className="outerbhram-container-footer">
                                            <div className="bhram-box bhrambox-footer animate-left">
                                                <img src="../images/BOR/bhramsatra-big.png" className="img-fluid bhramstone-big"></img>
                                            </div>
                                            <div className="bhram-points-box animate-right">
                                                <span className={` ${showNewText ? "fade-in-bottom" : ""}`}>{text}</span>
                                            </div>
                                        </div>
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </footer>

            <div id="bottomDrawerClick" className={`bottom-drawer-click ${isDrawerOpen ? 'show' : ''}`}>
                <div className="drawer-inner">
                    <footer id="drawerFooterClick" onClick={handleDrawerFooterClick}>
                        <div className="outercontainer">

                            <p className="teamnamef">{myKDName}</p>

                        </div>
                    </footer>
                    <div className="p-1">
                        <p className="drawertitle">REGION'S TOTAL BRAHMASTRA : <span>{war_data.my_kd_brahmastra}</span></p>
                    </div>
                    <div className="tabsnav-container" style={rmHideDiv}>
                        <div className="distheader">
                            <div className="dheading">
                                <p className="mb-0">Distributor's Ranking</p>
                            </div>
                            <div className="dicon" onClick={() => orderToggle()}>
                                <img src="../images/BOR/sorticon-new.png" className={`flip-card ${isFlipped ? "flipped" : ""}`} />
                            </div>
                        </div>
                        <ul className="nav nav-pills mb-2 nav-pillbox" id="pills-tab" role="tablist">
                            <li className="nav-item navitem-head">
                                <a className="nav-link nav-linksp active" id="pills-all-tab" data-toggle="pill"
                                    href="#all" role="tab" aria-controls="all" aria-selected="true">
                                    All</a>
                            </li>
                            {allServicesData}

                        </ul>
                        <div className="tab-content" id="pills-tabContent">
                            {distRanking}
                        </div>
                    </div>
                    <div className="tabsnav-container" style={distHideDiv}>
                        {/* <h1>distributor html goes here..</h1> */}

                        <ul className="nav nav-pills mb-3 nav-pillboxdist" id="pills-tab" role="tablist">
                            <li className="nav-item navitem-headmypoints">
                                <a className="nav-link nav-linksdist active" id="pills-home-tab" data-toggle="pill"
                                    href="#my_points" role="tab" aria-controls="pills-home" aria-selected="true">MY
                                    POINTS</a>
                            </li>
                            <li className="nav-item navitem-headmypoints">
                                <a className="nav-link nav-linksdist" id="pills-profile-tab" data-toggle="pill"
                                    href="#region_details" role="tab" aria-controls="pills-profile"
                                    aria-selected="false">REGION DETAILS</a>
                            </li>

                        </ul>
                        <div className="tab-content" id="pills-tabContent">
                            <div className="tab-pane fade show active" id="my_points" role="tabpanel"
                                aria-labelledby="pills-home-tab">
                                {myPoints}
                            </div>
                            <div className="tab-pane fade" id="region_details" role="tabpanel"
                                aria-labelledby="pills-profile-tab">
                                {regionDetails}
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <a data-toggle="modal" ref={rmUserPointsModal} data-target="#rm_user_points_modal"></a>
            <div className="modal fade rm-service-modal" id="rm_user_points_modal" tabIndex="-1" role="dialog" data-bs-backdrop="static"
                aria-labelledby="myLargeModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content service-modal">
                        <div className="p-2" id="regionDrawerToggle">
                            <p className="drawertitle mb-0">REGION'S TOTAL BRAHMASTRA : <span>{war_data.my_kd_brahmastra}</span>
                            </p>
                        </div>
                        {userRMPointsModel}
                    </div>
                </div>
            </div>

        </>
    );
}

export default Footer;